import { RowData, Table } from '@tanstack/table-core';
import React from 'react';

import TableFooter from './Footer';

function TableFoot<TData extends RowData>({ table }: { table: Table<TData> }) {
  return (
    <tfoot>
      {table.getFooterGroups().map((footerGroup) => (
        <tr key={footerGroup.id}>
          {footerGroup.headers.map((footer) => (
            <TableFooter<TData> key={footer.id} footer={footer} />
          ))}
        </tr>
      ))}
    </tfoot>
  );
}

export default TableFoot;
